import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { MainStoreState } from 'modules/main/store/MainStoreState';
import { StaffStoreState } from 'modules/staff/store/StaffStoreState';
import { SsrApiDataContextSelfErasingProvider } from 'rendering/api-data/SsrApiDataContextSelfErasingProvider';
import { AmpContext } from 'utils/AmpContext';

type Props = {
  store: Store<MainStoreState | StaffStoreState>;
  requestIsAmp: boolean;
  ssrApiData: Record<string, unknown>;
  children?: ReactNode;
};

export function RenderingWrapper({
  store,
  requestIsAmp,
  ssrApiData,
  children,
}: Props) {
  return (
    <Provider store={store}>
      <AmpContext.Provider value={requestIsAmp}>
        <SsrApiDataContextSelfErasingProvider ssrApiData={ssrApiData}>
          {children}
        </SsrApiDataContextSelfErasingProvider>
      </AmpContext.Provider>
    </Provider>
  );
}
